import { ErpTransferStatisticLine } from 'models/erp-transfer-statistic'
import { AnyAction } from 'redux'

export const ACTION_LOAD_ERP_TRANSFER_STATISTICS = 'ACTION_LOAD_ERP_TRANSFER_STATISTICS'
export const ACTION_LOAD_ERP_TRANSFER_STATISTICS_SUCCESS = 'ACTION_LOAD_ERP_TRANSFER_STATISTICS_SUCCESS'
export const ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED = 'ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED'
export const ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED_SUCCESS = 'ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED_SUCCESS'
export const ACTION_SET_ERROR_SNACKBAR_OPEN = 'ACTION_SET_ERROR_SNACKBAR_OPEN'
export const ACTION_SET_SEND_TO_ERP_RUNNING = 'ACTION_SET_SEND_TO_ERP_RUNNING'

export const actionLoadErpTransferStatisticsSuccess = (statistics: ErpTransferStatisticLine[]): AnyAction => ({
    type: ACTION_LOAD_ERP_TRANSFER_STATISTICS_SUCCESS,
    statistics,
})

export const actionLoadErpTransferStatistics = (year: number, id?: string): AnyAction => ({
    type: ACTION_LOAD_ERP_TRANSFER_STATISTICS,
    year,
    id,
})

export const actionSetTransferFinished = (statistics: ErpTransferStatisticLine): AnyAction => ({
    type: ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED,
    statistics,
})

export const actionSetErpTransferFinishedSuccess = (statistics: ErpTransferStatisticLine): AnyAction => ({
    type: ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED_SUCCESS,
    statistics,
})

export const setErrorSnackbarOpen = (open: boolean): AnyAction => ({
    type: ACTION_SET_ERROR_SNACKBAR_OPEN,
    open,
})

export const setSendToErpRunning = (sendToErpRunning: boolean): AnyAction => ({
    type: ACTION_SET_SEND_TO_ERP_RUNNING,
    sendToErpRunning,
})
